"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsArticlePage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var page_image_1 = require("../../../components/page_image");
var blogs_1 = require("../../../api/calls/strapi/blogs");
var react_redux_1 = require("react-redux");
var main_1 = require("../../../reducers/slices/main");
var react_router_dom_1 = require("react-router-dom");
var react_markdown_1 = __importDefault(require("react-markdown"));
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var NewsArticlePage = function (props) {
    var _a;
    var _b = props;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var params = (0, react_router_dom_1.useParams)();
    var blogID = params.blogID;
    var _c = (0, react_1.useState)([]), blogData = _c[0], setBlogData = _c[1];
    var _d = (0, react_1.useState)(false), loading = _d[0], setLoading = _d[1];
    (0, react_1.useEffect)(function () {
        setLoading(true);
        (0, blogs_1.get_blogs)({
            blogID: blogID,
        }).then(function (data) {
            setLoading(false);
            if (data) {
                setBlogData(data);
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Oops!",
                    messages: ["Sorry! We could not retrieve the news articles at the moment! Please try again later."],
                }));
            }
        });
    }, []);
    var LinkRenderer = function (_a) {
        var children = _a.children, href = _a.href;
        if (!href) {
            return react_1.default.createElement(react_1.default.Fragment, null, children);
        }
        return (react_1.default.createElement("a", { href: href, style: { color: "#FC4F06", textDecoration: "underline" } }, children));
    };
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null, loading ? (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "large" })) : (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Back", icon: pro_solid_svg_icons_1.faChevronLeft, textColor: "text-black", onClick: function () {
                        navigate("/news");
                    } })),
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: blogData.title, textColor: "text-black", size: "3xlarge", bold: true, center: true }),
            react_1.default.createElement("div", { className: "pb-24" },
                react_1.default.createElement(page_image_1.PageImageComponent, { image: "".concat(process.env.STRAPI_TLC_URL).concat((_a = blogData === null || blogData === void 0 ? void 0 : blogData.image) === null || _a === void 0 ? void 0 : _a.url) })),
            react_1.default.createElement(react_markdown_1.default, { components: { a: LinkRenderer } }, blogData.body))))));
};
exports.NewsArticlePage = NewsArticlePage;
